module.exports = __webpack_public_path__ + "images/emoji/angel.4743e976b21bd1b878fe.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/angel.png
// module id = iNik
// module chunks = 24